<template>
  <div :class="`block ${slug}`">
    <div class="title">
      <img :src="icon" :alt="title" />
      {{ title }} <span>{{ gamesCount }}</span>
      <router-link :to="{ name: 'category-topic', params: { topic: slug } }">Все</router-link>
      <div class="game">
        <swiper
          :slides-per-view="5"
          :modules="modules"
          :navigation="{ nextEl: '.block.' + slug + ' .game-next', prevEl: '.block.' + slug + ' .game-prev' }"
          :breakpoints="{
            '320': {
              slidesPerView: 3,
            },
            '460': {
              slidesPerView: 5,
            },
            '1350': {
              slidesPerView: 5,
            },
          }"
        >
          <swiper-slide v-for="game in this.gamesByTopic(slug)" :key="game.id + ':' + isAuthenticated">
            <router-link v-if="isAuthenticated" :to="{ name: 'game', params: { game: game.slug } }"
              ><img :src="game.icon" :alt="game.title" width="164" height="164" />
            </router-link>
            <router-link v-else :to="{ name: 'demo', params: { game: game.slug } }"
              ><img :src="game.icon" :alt="game.title" width="164" height="164" />
            </router-link>
          </swiper-slide>
        </swiper>
        <div class="game-prev slider-arrow slider-arrow-left" />
        <div class="game-next slider-arrow slider-arrow-right" />
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import { mapGetters } from 'vuex'
import { Navigation, Pagination } from 'swiper/modules'

export default {
  name: 'TopicSlider',
  components: { Swiper, SwiperSlide },
  props: {
    slug: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    gamesCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'gamesByTopic']),
  },
  setup() {
    const { t, n } = useI18n()
    const showTooltip = ref(false)
    return {
      t,
      n,
      showTooltip,
      modules: [Pagination, Navigation],
    }
  },
}
</script>

<style scoped></style>
